import { TariffViewModel } from '@common/model/billing/tariff/view';
import { getTariffPerMonthPrice } from './getPerMonthPrice';

export interface ITariffComparisonParameters {
  price: number;
  pricePerMonth: number;
  benefit: number;
  benefitPercentage: number;
}

export type ITariffsComparison<T = ITariffComparisonParameters> = {
  [tariffId: TariffViewModel['id']]: T;
};

export const compareTariffs = (tariffs: TariffViewModel[]): ITariffsComparison => {
  const comparison: ITariffsComparison = {};

  if (!tariffs.length) {
    return comparison;
  }

  const baseComparison: ITariffsComparison<Pick<ITariffComparisonParameters, 'price' | 'pricePerMonth'>> = {};
  let biggestPricePerMonth: number = 0;

  for (const t of tariffs) {
    if (!t.period) {
      continue;
    }
    const pricePerMonth = getTariffPerMonthPrice(t);

    baseComparison[t.id] = { price: t.price, pricePerMonth };
    biggestPricePerMonth = Math.max(biggestPricePerMonth, pricePerMonth);
  }

  for (const [id, { price, pricePerMonth }] of Object.entries(baseComparison)) {
    const benefit = biggestPricePerMonth - pricePerMonth;

    comparison[id] = {
      price,
      pricePerMonth,
      benefit,
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers, prettier/prettier
      benefitPercentage: parseInt(((1 - (pricePerMonth / biggestPricePerMonth)) * 100).toFixed(0)),
    };
  }

  return comparison;
};
